import React, { useState } from 'react';
import { axiosClient } from '../services/api';
import { useI18n } from '../i18n/i18nContext';

const NewsletterSubscription: React.FC = () => {
  const { t } = useI18n();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!firstName || !lastName || !email) return;

    setStatus('loading');
    try {
      await axiosClient.post('/api/newsletter/subscribe', {
        firstName,
        lastName,
        email,
      });
      setStatus('success');
      setFirstName('');
      setLastName('');
      setEmail('');
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <div id="newsletter" className="w-full bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className="mb-4 text-2xl font-bold text-gray-900">{t.newsletter.title}</h2>
        <p className="mb-8 text-gray-600">{t.newsletter.subtitle}</p>

        {status === 'success' ? (
          <div className="rounded-md bg-green-100 p-4 text-green-700">
            {t.newsletter.successMessage}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-4 sm:flex-row">
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder={t.newsletter.firstNamePlaceholder}
                required
                className="min-w-0 flex-1 rounded-md border border-gray-300 px-4 py-3 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
              />
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder={t.newsletter.lastNamePlaceholder}
                required
                className="min-w-0 flex-1 rounded-md border border-gray-300 px-4 py-3 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
              />
            </div>
            <div className="flex flex-col gap-4 sm:flex-row">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.newsletter.emailPlaceholder}
                required
                className="min-w-0 flex-1 rounded-md border border-gray-300 px-4 py-3 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-black"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-black px-6 py-3 text-base font-medium text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 disabled:opacity-50"
              >
                {status === 'loading' ? t.newsletter.subscribing : t.newsletter.subscribe}
              </button>
            </div>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-2 text-sm text-red-600">{t.newsletter.errorMessage}</p>
        )}
      </div>
    </div>
  );
};

export default NewsletterSubscription;
